export default __webpack_public_path__ + "static/media/stadium-bg-ar.38623b62.png";